import { render, staticRenderFns } from "./tic.vue?vue&type=template&id=0b63674e&scoped=true&"
import script from "./tic.vue?vue&type=script&lang=js&"
export * from "./tic.vue?vue&type=script&lang=js&"
import style0 from "./tic.vue?vue&type=style&index=0&id=0b63674e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63674e",
  null
  
)

export default component.exports